export default "__VITE_ASSET__86ddabc4__"